import { useQuery } from '@tanstack/react-query';
import {
  GetAdminPermissionsEntity,
  UserWalletAuthService,
} from 'services/openapi';
import { AuthQueryKeys } from './constants';

export const useGetAdminPermissionsQuery = () => {
  const queryKey = [AuthQueryKeys.GET_ADMIN_PERMISSIONS];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GetAdminPermissionsEntity, Error>({
    queryKey,
    queryFn: () => UserWalletAuthService.authControllerGetAdminPermissions(),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data: data,
    isError,
    queryKey,
    refetch,
  };
};
